import { SmileOutlined } from "@ant-design/icons";
import { Result } from "antd";

const Dashboard = () => {

    return (
        <div className="flex justify-content-center	 align-items-center h-full">
            <Result
                icon={<SmileOutlined />}
                title={
                    <span className="page-title">
                        Dashboard Coming Soon!
                    </span>
                }
                subTitle="We're working hard to bring you a beautiful dashboard experience. Stay tuned!"
                className="max-w-25rem"
            />
        </div>
    );
};

export default Dashboard;
